
import { useNavigate } from "react-router-dom";
import { useBrandingContext } from "@/components/BrandingProvider";
import { useEffect, useState } from "react";
export interface BrandLogoProps {
  agencyName?: string | null;
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  hideText?: boolean;
}
export function BrandLogo({
  agencyName,
  size = "md",
  hideText = true // Changed default to true to hide text always
}: BrandLogoProps) {
  const {
    logo,
    primaryColor,
    isLoading,
    refreshBranding
  } = useBrandingContext();
  const navigate = useNavigate();
  const [logoSrc, setLogoSrc] = useState<string | null>(logo);

  // Atualize o logoSrc sempre que o logo do contexto mudar
  useEffect(() => {
    if (logo !== logoSrc) {
      setLogoSrc(logo);
    }
  }, [logo]);

  // Force refresh on mount to ensure we have the latest branding
  useEffect(() => {
    refreshBranding();
  }, []);
  const displayName = agencyName || '';

  // Size configuration with 25% increase in dimensions from previous values
  const logoSize = {
    sm: {
      container: "h-11 w-11", // 9 -> 11 (25% increase)
      text: "text-base"
    },
    md: {
      container: "h-12 w-12", // 10 -> 12 (25% increase) 
      text: "text-lg"
    },
    lg: {
      container: "h-20 w-20", // 16 -> 20 (25% increase)
      text: "text-xl"
    },
    xl: {
      container: "h-[188px] w-[100px]", // 150x80 -> 188x100 (25% increase)
      text: "text-2xl"
    },
    "2xl": {
      container: "h-[244px] w-[130px]", // 195x104 -> 244x130 (25% increase)
      text: "text-3xl"
    }
  }[size];

  // Adicionar um timestamp para evitar cache da imagem
  const logoUrl = logoSrc ? `${logoSrc}?t=${new Date().getTime()}` : null;
  return <div onClick={() => navigate("/")} className="flex items-center space-x-2 cursor-pointer" data-testid="brand-logo">
      {logoUrl ? <img src={logoUrl} alt="Logo" className={`${logoSize.container} object-contain`} onError={() => setLogoSrc(null)} // Handle loading errors
    /> : <div className={`flex items-center justify-center ${logoSize.container} rounded-md font-bold text-white`} style={{
      backgroundColor: primaryColor || '#0448ff'
    }}>
          {displayName ? displayName.substring(0, 1).toUpperCase() : ''}
        </div>}
      {/* Text display has been removed by setting hideText default to true */}
    </div>;
}
